import React from 'react';
import { Card } from './ui/card';
import { Star, Quote } from 'lucide-react';

const ReviewCard = ({ review }) => {
  return (
    <Card className="p-6 bg-white shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-[#FFC222] rounded-xl">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h4 className="font-bold text-lg text-gray-900">{review.name}</h4>
          <p className="text-sm text-gray-500">{review.date}</p>
        </div>
        <Quote className="w-8 h-8 text-[#FFC222] opacity-50" />
      </div>
      
      <div className="flex gap-1 mb-4">
        {[...Array(review.rating)].map((_, i) => (
          <Star key={i} className="w-5 h-5 fill-[#FFC222] text-[#FFC222]" />
        ))}
      </div>
      
      <p className="text-gray-700 leading-relaxed">{review.text}</p>
    </Card>
  );
};

export default ReviewCard;
